import * as React from 'react';
import { createViewConfig } from '@sail/engine';
import { Action } from './Action';
import { IconConfig } from './Icon';
import { css } from '../css';
export const LinkConfig = createViewConfig({
    props: {},
    name: 'Link',
    flattens: true,
    defaults: {
        type: 'primary',
        disabled: false
    }
});
/**
 * A link is a clickable element that navigates to another page or resource.
 */ export const Link = LinkConfig.createView((props)=>{
    return /*#__PURE__*/ React.createElement(Action, props);
}, {
    uses: [
        IconConfig.customize({
            defaults: {
                size: 'xsmall'
            }
        })
    ],
    forward: {
        disabled: true
    },
    variants: {
        type: {
            primary: css({
                color: 'action.primary',
                ':hover': {
                    color: 'action.primary.hovered'
                }
            }),
            secondary: css({
                color: 'action.secondary',
                textDecoration: 'underline',
                textDecorationColor: 'action.secondary',
                textDecorationStyle: 'solid',
                textUnderlineOffset: '2px',
                textDecorationThickness: '0.07em',
                ':hover': {
                    color: 'action.secondary.hovered',
                    textDecorationColor: 'action.secondary.hovered',
                    textDecorationStyle: 'solid'
                }
            })
        },
        disabled: {
            true: css({
                color: 'action.primary.disabled',
                textDecoration: 'none',
                ':hover': {
                    color: 'action.primary.disabled',
                    cursor: 'default'
                }
            })
        }
    },
    css: {
        baselineAlign: 'auto',
        fontWeight: 'inherit',
        // TODO(koop): We likely can remove the height/width properties here,
        //   which will make it easier to create block links.
        height: 'fit',
        width: 'fit',
        borderRadius: 'xsmall',
        gap: 'small'
    }
});

//# sourceMappingURL=Link.js.map